import { render, staticRenderFns } from "./top-5-queries.vue?vue&type=template&id=504b6f92&scoped=true&"
import script from "./top-5-queries.vue?vue&type=script&lang=js&"
export * from "./top-5-queries.vue?vue&type=script&lang=js&"
import style0 from "./top-5-queries.vue?vue&type=style&index=0&id=504b6f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b6f92",
  null
  
)

component.options.__file = "top-5-queries.vue"
export default component.exports